export const approvalMenuList = [
  {
    label: "전체",
    path: "/loa/all",
    bpName: "",
  },
  {
    label: "업체 등록 품의",
    path: "/loa/vendorsEvaluation",
    bpName: "Vendors Evaluation Approval",
  },
  {
    label: "입찰/계약 요청 품의",
    path: "/loa/requestContract",
    bpName: "Contract Request Approval",
  },
  {
    label: "입찰 진행 품의",
    path: "/loa/bidStart",
    bpName: "Initiate Bid Approval",
  },
  {
    label: "입찰 종료 품의",
    path: "/loa/bidFinish",
    bpName: "Finalize Bid Approval",
  },
  {
    label: "계약 품의",
    path: "/loa/contract",
    bpName: "SHI Contract Approval",
  },
  {
    label: "변경계약 요청 품의",
    path: "/loa/requestChangeOrder",
    bpName: "SHI CO Req Approval",
  },
  {
    label: "변경계약 품의",
    path: "/loa/changeOrder",
    bpName: "SHI CO Approval",
  },
  {
    label: "기성 품의",
    path: "/loa/payment",
    bpName: "SPA Approval",
  },
  {
    label: "선급금 품의",
    path: "/loa/advancePayment",
    bpName: "Advance Payment Approval",
  },
];
